import { Component } from '@angular/core';

@Component({
  selector: 'app-payout-main',
  templateUrl: './payout-main.component.html',
  styleUrls: ['./payout-main.component.css']
})
export class PayoutMainComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }

}
